/* Zelesta cart drawer — upsell add-to-cart, slider nav, qty helpers */

(function () {
  /* ── Upsell add-to-cart ── */
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;

    var variantId = parseInt(btn.dataset.upsellAdd, 10);
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('zcd__upsell-add-btn--loading');

    try {
      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      if (!addRes.ok) throw new Error('Cart add failed');

      /*
       * Let Dawn's CartDrawerItems.onCartUpdate() handle the DOM refresh.
       * publish/PUB_SUB_EVENTS are global (pubsub.js / constants.js).
       */
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-add' });

      /* Update cart count + icon bubble */
      var cartData = await fetch('/cart.js').then(function (r) { return r.json(); });
      var count = cartData.item_count;

      /* Cart page heading + drawer heading */
      var countEl = document.querySelector('.zcp__heading-count');
      if (countEl) countEl.textContent = '(' + count + ')';
      var drawerCountEl = document.querySelector('.zcd__header-count');
      if (drawerCountEl) {
        drawerCountEl.textContent = '(' + count + ')';
      } else if (count > 0) {
        var titleEl = document.querySelector('.zcd__header-title');
        if (titleEl) {
          var newSpan = document.createElement('span');
          newSpan.className = 'zcd__header-count';
          newSpan.textContent = '(' + count + ')';
          titleEl.appendChild(newSpan);
        }
      }

      /* Cart icon bubble — update directly without re-fetching section */
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var countBubble = bubble.querySelector('.cart-count-bubble');
        if (count > 0) {
          if (countBubble) {
            var vis = countBubble.querySelector('[aria-hidden="true"]');
            var hid = countBubble.querySelector('.visually-hidden');
            if (vis) vis.textContent = count;
            if (hid) hid.textContent = count + ' items';
          } else {
            var nb = document.createElement('span');
            nb.className = 'cart-count-bubble';
            nb.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
            bubble.appendChild(nb);
          }
        } else if (countBubble) {
          countBubble.remove();
        }
      }

      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.remove('is-empty');

    } catch (err) {
      console.error('[Zelesta] Upsell add-to-cart:', err);
    } finally {
      btn.disabled = false;
      btn.classList.remove('zcd__upsell-add-btn--loading');
    }
  });

  /* ── Upsell slider nav arrows ── */
  function updateArrows(cards) {
    var upsell = cards.closest('.zcd__upsell');
    if (!upsell) return;
    var prevBtn = upsell.querySelector('.zcd__upsell-nav-btn--prev');
    var nextBtn = upsell.querySelector('.zcd__upsell-nav-btn--next');
    var atStart = cards.scrollLeft <= 1;
    var atEnd = cards.scrollLeft >= cards.scrollWidth - cards.clientWidth - 1;
    if (prevBtn) prevBtn.disabled = atStart;
    if (nextBtn) nextBtn.disabled = atEnd;
  }

  /* Scroll listener (capture phase — scroll doesn't bubble) */
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('zcd__upsell-cards')) {
      updateArrows(e.target);
    }
  }, true);

  /* Click: scroll then re-check arrows after animation */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.zcd__upsell-nav-btn');
    if (!btn) return;
    var upsell = btn.closest('.zcd__upsell');
    if (!upsell) return;
    var cards = upsell.querySelector('.zcd__upsell-cards');
    if (!cards) return;
    var card = cards.querySelector('.zcd__upsell-card');
    var scrollAmount = card ? card.offsetWidth + 10 : 220;
    if (btn.classList.contains('zcd__upsell-nav-btn--prev')) {
      cards.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      cards.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
    setTimeout(function () { updateArrows(cards); }, 380);
  });

  /* ── Drag-to-scroll (mouse desktop + touch fallback) ── */
  function initDragScroll(el) {
    if (el._dragInit) return;
    el._dragInit = true;

    var isDown = false;
    var startX, scrollLeft, dragged;

    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      dragged = false;
      startX = e.pageX - el.getBoundingClientRect().left;
      scrollLeft = el.scrollLeft;
      el.classList.add('is-dragging');
      e.preventDefault();
    });

    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('is-dragging');
      if (!dragged) return;
      var card = el.querySelector('.zcd__upsell-card');
      var cardWidth = card ? card.offsetWidth + 10 : 230;
      var startIndex = Math.round(scrollLeft / cardWidth);
      var delta = el.scrollLeft - scrollLeft;
      var threshold = cardWidth * 0.25;
      var targetIndex = startIndex;
      if (delta > threshold) targetIndex = startIndex + 1;
      else if (delta < -threshold) targetIndex = startIndex - 1;
      var maxIndex = Math.round((el.scrollWidth - el.clientWidth) / cardWidth);
      targetIndex = Math.max(0, Math.min(targetIndex, maxIndex));
      el.scrollTo({ left: targetIndex * cardWidth, behavior: 'smooth' });
      setTimeout(function () { updateArrows(el); }, 380);
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var x = e.pageX - el.getBoundingClientRect().left;
      var walk = x - startX;
      if (Math.abs(walk) > 4) dragged = true;
      el.scrollLeft = scrollLeft - walk * 1.5;
    });

    el.addEventListener('click', function (e) {
      if (dragged) {
        e.preventDefault();
        e.stopImmediatePropagation();
        dragged = false;
      }
    }, true);
  }

  function initUpsellNav() {
    document.querySelectorAll('.zcd__upsell-cards').forEach(function (cards) {
      updateArrows(cards);
      initDragScroll(cards);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsellNav);
  } else {
    initUpsellNav();
  }

  /* Re-init after Dawn AJAX cart refresh */
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(initUpsellNav, 80);
    });

    /* Update cart heading count + icon bubble on every cart change */
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* "Your cart (X)" heading */
          var countEl = document.querySelector('.zcp__heading-count');
          if (countEl) countEl.textContent = '(' + cart.item_count + ')';

          /* Cart icon bubble */
          var cartUrl = (window.ZcdRoutes && window.ZcdRoutes.cartUrl) || '/cart';
          return fetch(cartUrl + '?section_id=cart-icon-bubble')
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var bubble = document.getElementById('cart-icon-bubble');
              var newBubble = doc.getElementById('cart-icon-bubble');
              if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;
            });
        })
        .catch(function () {});
    });
  }

  /* Re-init when upsell cards are injected into the DOM (e.g. drawer first open) */
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node.querySelectorAll) return;
        node.querySelectorAll('.zcd__upsell-cards').forEach(function (cards) {
          updateArrows(cards);
          initDragScroll(cards);
        });
        if (node.classList && node.classList.contains('zcd__upsell-cards')) {
          updateArrows(node);
          initDragScroll(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* ── Qty input → update data-qty on minus button ── */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.zcd__qty-val, .quantity__input');
    if (!input) return;
    var pill = input.closest('.zcd__qty-pill');
    if (!pill) return;
    var minusBtn = pill.querySelector('.zcd__qty-btn--minus');
    if (minusBtn) minusBtn.dataset.qty = input.value;
  });

  /*
   * Trash-icon remove: intercept minus-button click when qty=1 and call
   * CartDrawerItems.updateQuantity(index, 0) directly, bypassing Dawn's
   * data-min validation. useCapture:true fires before QuantityInput's listener.
   */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.zcd__qty-btn--minus');
    if (!btn || btn.dataset.qty !== '1') return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var input = btn.closest('quantity-input').querySelector('.quantity__input');
    if (!input) return;

    var cartItems = btn.closest('cart-drawer-items');
    if (!cartItems || typeof cartItems.updateQuantity !== 'function') return;

    cartItems.updateQuantity(input.dataset.index, 0, e);
  }, true); /* capture phase */
})();
